//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Action, Paper } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import IllustrationShinnyCoin from '@core/illustrations/IllustrationShinnyCoin.svg'
import { trackClick } from '@tracking/events'

import translations from './Help.translations'

export default {
  components: {
    Action,
    Paper,
    IllustrationShinnyCoin,
  },
  computed: {
    ...mapGetters({
      faqUrl: 'config/getFaqUrl',
    }),
    translations: () => translations,
  },

  methods: {
    track() {
      trackClick({ name: 'faq-ad' })
    },
  },
}
